import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import ScrollToTop from "react-scroll-to-top";

import kps_admissionform from "../images/KPS_e-Admission Form.pdf";


function CritariaAdmission() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>


            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Criteria of Admission <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />
            <div className="container">
                <div className='welcometext'>
                    <h1 className="card-title mb-0"><b>Age Criteria for Admission</b></h1>
                    <div className="col-md-3">
                        <hr style={{ color: "#1D4D93" }} />
                    </div>
                </div>
            </div>
            <div className="album py-1">
                <div className="container">

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Class</th>
                                <th>Age Limit</th>
                                <th>Class</th>
                                <th>Age Limit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Play Group</td>
                                <td>3+</td>
                                <td>Nursery</td>
                                <td>4+</td>
                            </tr>
                            <tr>
                                <td>KG</td>
                                <td>5+</td>
                                <td>Class I</td>
                                <td>6+</td>
                            </tr>
                            <tr>
                                <td>Class II</td>
                                <td >	7+</td>
                                <td>Class III	</td>
                                <td>8+</td>
                            </tr>




                            <tr>
                                <td>Class IV</td>
                                <td> 9+</td>
                                <td>Class V	</td>
                                <td>10+</td>

                            </tr>


                            <tr>
                                <td>Class VI</td>
                                <td> 11+</td>
                                <td>Class VII	</td>
                                <td>12+</td>

                            </tr>


                            <tr>
                                <td>Class VIII</td>
                                <td> 13+</td>
                                <td>Class IX	</td>
                                <td>14+</td>

                            </tr>
                            <tr>
                                <td>Class X</td>
                                <td> 15+</td>
                                <td>Class XI	</td>
                                <td>16+</td>
                            </tr>
                            <tr>
                                <td>Class XII</td>
                                <td>17+</td>
                                <td>	</td>
                                <td></td>
                            </tr>


                        </tbody>
                    </Table>
                </div>
            </div>
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b>Criteria Of Admission</b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-12 mt-3">
                                        <div className='mission'>
                                            <p className='justify mb-2'>Registration does not imply admission; it is subject to availability of seats and fulfilling of admission criteria.  </p>
                                            <p className='justify mb-2'>Parents may collect Prospectus and Registration Form from School Office or download it from the School Website or use the Link provided below. </p>
                                            <p className='justify mb-2'> The duly filled in Registration form, to be submitted at the school office</p>
                                            <p className='justify mb-2'> After registration, the child is required to appear for an Interview/Admission Test.</p>

                                            <p className='justify mb-2'> Fees once deposited will not be refunded.</p>
                                            <p className='justify mb-2'> Mode of payment is by Cheque/ Cash /Debit Card /Credit Card /Online transfer.</p>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <div className="d-flex justify-content-start align-items-start mt-3 mb-0">
                                        <a href={kps_admissionform} target="_blank" rel="noopener noreferrer">
                                        <div className='teamkps'>
                                            <button className='Addmission mb-0'>Download Admission Form <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-arrow-down" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z" />
                                                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                            </svg>

                                            </button>

                                        </div>
                                        </a>

                                    </div>



                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />


        </div>
    )
}

export default CritariaAdmission